import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { Form, Row, Col, FloatingLabel, Button, Spinner, Navbar } from 'react-bootstrap';
import { Formik, ErrorMessage } from "formik";
import { useSelector } from 'react-redux';
import { selectLoading, login } from '../auth.slice';
import { useHistory } from "react-router-dom";
import { toggle } from '../../../parts/offcanvas/offcanvas.slice';
import { selectCartInsuranceCost, selectCartItems, selectFinalPrice, selectHasInsurance, selectCartUpsellings } from '../../cart-info/cart-info.slice';
import { showAlert } from '../../alert/alert.slice';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import * as Yup from "yup";

export default function Login() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const queryParams = queryString.parse(history.location.search);
  const loading = useSelector(selectLoading);
  const cartItems = useSelector(selectCartItems);
  const finalPrice = useSelector(selectFinalPrice);
  const cartInsuranceCost = useSelector(selectCartInsuranceCost);
  const hasInsurance = useSelector(selectHasInsurance);
  const cartUpsellings = useSelector(selectCartUpsellings);

  const validationSchema = Yup.object({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
  });

  const initialValues = {
    email: "",
    password: "",
  };

  const onSubmit = async (values, { setErrors, resetForm }) => {
    dispatch(login(values)).then((response) => {
      if (response?.error) {
        setErrors(response.payload);
        dispatch(showAlert({ variant: 'danger', message: t("ALERT.ERROR.LOGIN") }));

      } else {
        if (queryParams?.redirect) history.push(decodeURI(queryParams?.redirect));
        else history.push("/account" + history.location.search);
      }
    });
  };

  const renderError = (message) => <Form.Control.Feedback type="invalid">{[message]?.join(' ')}</Form.Control.Feedback>;

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
        }) => (
          <Form
            noValidate
            onSubmit={handleSubmit}
          >
            <Row>
              <Col md={6}>
                <FloatingLabel controlId="email" label={t("LOGIN.FORM.INPUT.EMAIL")} className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder={t("LOGIN.FORM.INPUT.EMAIL")}
                    value={values?.email}
                    isInvalid={touched?.email && !!errors?.email}
                    onChange={handleChange}
                  />
                  <ErrorMessage name="email" render={renderError} />
                </FloatingLabel>
              </Col>

              <Col md={6}>
                <FloatingLabel controlId="password" label={t("LOGIN.FORM.INPUT.PASSWORD")} className="mb-3">
                  <Form.Control
                    type="password"
                    placeholder={t("LOGIN.FORM.INPUT.PASSWORD")}
                    value={values?.password}
                    isInvalid={touched?.password && !!errors?.password}
                    onChange={handleChange}
                  />
                  <ErrorMessage name="password" render={renderError} />
                </FloatingLabel>
              </Col>
            </Row>

            <Button variant="dark" size="lg" type="submit" className="d-none d-lg-block" disabled={loading}>
              {loading ?
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                :
                <>{t("LOGIN.FORM.BUTTON.SUBMIT")}</>
              }
            </Button>
            <Link className="float-end small text-dark text-decoration-none" to={'forgot?eventSession=' + queryParams?.eventSession}>{t("LOGIN.BUTTON.FORGOT")}</Link>

            <Row>
              <Navbar fixed="bottom" bg="light" className="d-lg-none shadow">
                {cartItems?.length ? <Button variant="light" size="lg" className="shadow flex-fill" style={{ marginRight: '1.25rem' }} onClick={() => dispatch(toggle())}>{(Number(finalPrice) + (hasInsurance ? Number(cartInsuranceCost) : 0) + (cartUpsellings?.reduce((acumulator, currentValue) => Number(acumulator) + (Number(currentValue.price) * Number(currentValue.quantity)), 0))).toFixed(2)} €</Button> : null}
                <Button variant="dark" size="lg" type="submit" className="shadow flex-fill" disabled={loading}>
                  {loading ?
                    <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                    :
                    <>{t("LOGIN.FORM.BUTTON.SUBMIT")}</>
                  }
                </Button>
              </Navbar>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
